export const SET_GENES = 'SET_GENES';

export function setGenes(genes, id) {
  return { type: SET_GENES, genes, id };
}
